class Url{
  /**
   * Set url params
   * @param {object} params
   */
  static setQueryParams(params){
    const urlParams = new URLSearchParams();
    for(let key of Object.keys(params)){
      if (Array.isArray(params[key]) || typeof params[key] === 'object') {
        urlParams.set(key, JSON.stringify(params[key]))
      } else {
        urlParams.set(key, params[key])
      }
    }
    this._updateUrl(urlParams)
  }

  /**
   * Set url parameter value
   * @param {string} key
   * @param {any} value
   */
  static setQueryParam(key, value){
    const params = new URLSearchParams(window.location.search)
    // const params = queryString.parse(window.location.search)
    if (Array.isArray(value) || typeof value === 'object')
      params.set(key, JSON.stringify(value))
    else
      params.set(key, value)
    this._updateUrl(params)
  }

  /**
   * Get url parameter value
   * @param {string} key
   * @returns {string}
   */
  static getParam(key){
    const params = new URLSearchParams(window.location.search)
    // const params = queryString.parse(window.location.search)
    return params.get(key)
  }

  /**
   * Update url parameters
   * @param {URLSearchParams} params
   * @private
   */
  static _updateUrl(params){
    // Update the url without triggering page refresh
    let search = '?' + params.toString()
    const hashParts = window.location.hash.split('#')
    if (hashParts.length > 1) {
      search += '#' + hashParts.slice(-1)[0]
    }
    window.history.replaceState(null, null, search)
  }
}

export default Url